/**
 * Picture already shown on the @mention row, keyed by agent id so the selector
 * can paint it before full agent details load and still find it afterwards.
 */
const avatarUrlsByAgentId = new Map<string, string>();

export const agentAvatarCache = {
	set(agentId: string, avatarUrl: string | undefined): void {
		if (avatarUrl) {
			avatarUrlsByAgentId.set(agentId, avatarUrl);
		}
	},
	get(agentId: string): string | undefined {
		return avatarUrlsByAgentId.get(agentId);
	},
	clear(): void {
		avatarUrlsByAgentId.clear();
	},
};
